import React, { Component } from 'react';
import { withAsyncHandlers, asyncConnect } from 'react-async-client';
import { Modal, Row, Col, Button, message } from 'antd';
import Translate from 'react-translate-component';
import * as yup from 'yup';
import { translate } from 'react-translate-component';
import { path } from 'ramda';
import { FormSpy } from 'react-final-form';

import withFormWrapper from 'components/hocs/withFormWrapper';
import { getUser, getPersonStateMenu, putPersonState } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import { openModalEventCreate } from 'actions/modalActions';
import ErrorHTML from 'components/common/form/ErrorHTML';
import { PROBATION_STATES, EMPLOYEED_STATES, EXCLUDED_STATES } from 'constants/person';
import { hasWhoTrudo } from 'helpers/personHelper';
import PersonStateFields, { onChangeStage } from './PersonStateFields';
import StateNeedEvents from './StateNeedEvents';
import ListenerField from 'components/common/form/ListenerField';

const stateToProps = state => ({
    user: getUser.selectData(state)
});

const validationSchema = (props, values) => {
    const { projectTypeId } = props.params;
    switch(values.idm) {
        case PROBATION_STATES[0]:
        case PROBATION_STATES[1]:
            return yup.object().shape({
                idm: yup.number().required(),
                whoTrudoId: hasWhoTrudo(projectTypeId) ? yup.number().nullable().required() : yup.number().nullable(),
                come_to_work_date: yup.string().required(),
                endOfTrial: yup.string().required(),
                position: yup.string().required(),
                salary: yup.number().default(null).nullable().required(),
                salaryCurrency: yup.number().required(),
            })
        case EMPLOYEED_STATES[0]:
        case EMPLOYEED_STATES[1]: {
            return yup.object().shape({
                idm: yup.number().required(),
                whoTrudoId: hasWhoTrudo(projectTypeId) ? yup.number().nullable().required() : yup.number().nullable(),
                come_to_work_date: yup.string().required(),
                position: yup.string().nullable().required(),
                salary: yup.number().default(null).nullable().required(),
                salaryCurrency: yup.number().required(),
            })
        }
        case EXCLUDED_STATES[0]:
        case EXCLUDED_STATES[1]: {
            return yup.object().shape({
                idm: yup.number().required(),
                comment: yup.string().required(),
            })
        }
        default:
            return yup.object().shape({
                idm: yup.number().required(),
            })
    }
};

@asyncConnect({
    getPersonStateMenu: getPersonStateMenu
        .withPayload(({ params: { personId, projectId } }) => ({
            personId,
            projectId
        }))
        .withOptions(fullAutoOptions),
    formAction: putPersonState
        .withOptions({ resetOnUnmount: true }),
}, stateToProps, { openModalEventCreate })
@withFormWrapper({
    mapPropsToValues: ({ params }) => ({
        peopleId: params.personId,
        projectId: params.projectId,
        organization: params.organization,
        position: params.position,
        department: params.department,
        salaryCurrency: 1,
        feeCurrency: 1,
    }),
    validationSchema
})
@withAsyncHandlers({
    getPersonStateMenu: {
        successHandler: (props, { payload }) => {
            const stage = path(['menu', 0, 'idm'], payload);
            onChangeStage(props, stage);
            props.form.change('idm', stage);
        },
    },
    formAction: {
        successHandler: ({ close }, { payload }) => {
            if (!payload.needContacts) {
                message.success(translate('worksheet.messages.personStateChanged'));
                close();
            }
        },
    },
})
export default class PersonStateModal extends Component {
    renderFooter() {
        const { formAction: { meta, data }, handleSubmit, close } = this.props;
        const needContacts = path(['needContacts'], data);

        return (
            <Row>
                <Col xs={{ span: 16 }} className="alert-inline">
                    <ErrorHTML meta={meta} />
                </Col>
                <Col xs={{ span: 8 }}>
                    <Button onClick={close}>
                        <Translate content='events.cancel' />
                    </Button>
                    <Button type='primary' onClick={handleSubmit} disabled={meta.pending || needContacts}>
                        <Translate content='events.transfer' />
                    </Button>
                </Col>
            </Row>
        );
    }

    render() {
        const { user, formAction, openModalEventCreate, getPersonStateMenu, modal, params, form } = this.props;
        const title = params.personName;

        return (
            <Modal
                {...modal}
                title={title}
                footer={this.renderFooter()}
            >
                <ListenerField
                    listenFieldName='idm'
                >
                    { (values) => (
                        <PersonStateFields
                            dictionaryAction={getPersonStateMenu}
                            menu={getPersonStateMenu.data.menu}
                            whoId={getPersonStateMenu.data.who}
                            participators={params.participators || []}
                            values={values}
                            form={form}
                            params={params}
                            user={user}
                            resetPersonState={formAction.reset}
                        />
                    )}
                </ListenerField>
                <FormSpy>
                    { ({ values }) => (
                        <StateNeedEvents
                            putPersonState={formAction}
                            params={params}
                            values={values}
                            openModalEventCreate={openModalEventCreate}
                            user={user}
                        />
                    )}
                </FormSpy>
            </Modal>
        );
    }
}
